import { Field, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  RenderingProps,
  TranslationOptionsParams,
} from '@/shared/shared.types';

export type C31IconCTABorderedProps = RenderingProps<
  C31IconCTABorderedFields,
  C31IconCTABorderedParams
>;

export type C31IconCTABorderedFields = {
  Headline: Field<string>;
  SupportCopy?: RichTextField;
  SupportCopyBottom?: RichTextField;
};

export type C31IconCTABorderedParams = {
  HeadlineTag?: string;
  NumberOfColumns?: string;
} & DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams;
